var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 50,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 50,
    fill: "#000",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M89.48 16.288c-2.24 0-4.056-1.857-4.056-4.148 0-2.29 1.815-4.148 4.055-4.148 2.24 0 4.056 1.857 4.056 4.148 0 2.291-1.816 4.148-4.056 4.148Zm0-1.267c1.554 0 2.815-1.29 2.815-2.88 0-1.592-1.26-2.881-2.816-2.881-1.555 0-2.816 1.29-2.816 2.88 0 1.591 1.26 2.88 2.816 2.88ZM61.989 12.601v2.535h3.267v.922h-4.507V8.338h4.507v.922h-3.267v2.42h2.929v.921h-2.93ZM69.65 9.26v6.798h-1.239V9.26h-1.915v-.922h5.07v.922H69.65ZM80.692 9.26v6.798h-1.239V9.26h-1.915v-.922h5.07v.922h-1.916Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.41 8.338h-1.24v7.72h1.24v-7.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M95.788 8.338h.225l3.38 5.649V8.338h1.239v7.72h-1.24l-3.604-6.025v6.025h-1.24v-7.72h1.24ZM56.106 11.814H59.5l-.033 1.098h-3.36v-1.098Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m58.834 9.23-.776.793c-.484-.506-1.172-.783-1.965-.783-1.587 0-2.873 1.314-2.873 2.934s1.286 2.935 2.873 2.935c1.586 0 2.712-.937 2.71-2.935.002-.123 0-.243-.008-.36h.99v.04c.373 2.798-1.49 4.408-3.726 4.387-2.199-.003-3.98-1.82-3.98-4.067 0-2.246 1.781-4.067 3.98-4.067 1.15 0 2.115.41 2.776 1.123ZM122.3 22.165h6.392s3.68.64 3.68 4.957c0 4.319-3.68 4.958-3.68 4.958H122.3v-9.915Zm1.24 2.398v5.321h4.339s1.975 0 1.975-2.66-1.975-2.66-1.975-2.66h-4.339Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.991 22.164h-2.255v16.131h2.255v-16.13ZM135.942 22.164h-2.255v16.131h2.255v-16.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M144.302 37.142c-.621.523-1.614 1.016-3.182 1.116-3.593.23-3.595-3.121-3.595-3.347 0-.226-.177-2.958 2.681-3.393 2.024-.307 3.441.205 4.096.53v-.473c-.161-.628-.659-1.781-2.154-1.781-2.053 0-2.506 1.134-2.506 1.134l-1.879-1.134s1.051-2.215 4.205-2.215c3.922 0 4.589 2.764 4.589 3.695v7.016h-2.255v-1.148Zm-.161-3.456s-4.344-1.196-4.495 1.298c-.151 2.494 4.167 1.296 4.553-.472 0-.562-.058-.826-.058-.826ZM150.787 37.683l-4.02-9.758h2.255l2.893 7.021 2.869-6.965h2.255l-6.1 14.807h-2.255l2.103-5.105ZM116.689 31.696l-7.131 3.012s.46 1.666 2.604 1.677c1.679.009 2.627-1.521 2.627-1.521l1.81 1.252s-1.46 2.413-4.451 2.413c-3.675 0-5.293-3.283-5.293-5.416 0-2.055 1.285-5.534 5.065-5.534 3.781 0 4.769 4.117 4.769 4.117Zm-2.713-.854s-.897-1.395-2.273-1.137c-2.911.544-2.545 3.147-2.545 3.147l4.818-2.01Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.856 22.164h-2.386v16.097h2.386V22.164Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m99.653 27.93 2.205.019v10.156c0 2.595-1.511 5.335-5.07 5.335-3.56 0-4.71-3.223-4.71-3.223l2.026-.87s.618 1.986 2.789 1.986c2.472 0 2.76-2.299 2.76-3.086v-1.102s-.855 1.368-2.98 1.368c-2.303 0-5.04-2.017-5.04-5.455 0-3.439 2.577-5.405 5.067-5.477 1.995-.057 2.953 1.353 2.953 1.353v-1.005Zm-2.791 8.52c1.608 0 2.912-1.506 2.912-3.363s-1.304-3.363-2.912-3.363c-1.609 0-2.912 1.506-2.912 3.363s1.303 3.362 2.912 3.362ZM85.275 38.525c-2.965 0-5.368-2.45-5.368-5.473 0-3.022 2.404-5.473 5.368-5.473 2.965 0 5.368 2.45 5.368 5.473 0 3.023-2.403 5.473-5.368 5.473Zm-.035-2.146c1.666 0 3.017-1.49 3.017-3.327s-1.35-3.326-3.017-3.326c-1.666 0-3.017 1.489-3.017 3.326 0 1.838 1.35 3.327 3.017 3.327ZM73.663 38.525c-2.964 0-5.367-2.45-5.367-5.473 0-3.022 2.403-5.473 5.367-5.473 2.965 0 5.368 2.45 5.368 5.473 0 3.023-2.403 5.473-5.368 5.473Zm-.035-2.146c1.666 0 3.017-1.49 3.017-3.327s-1.35-3.326-3.017-3.326c-1.666 0-3.017 1.489-3.017 3.326 0 1.838 1.35 3.327 3.017 3.327ZM59.802 29.314h7.086l-.07 2.29h-7.016v-2.29Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m65.495 23.928-1.622 1.653c-1.011-1.054-2.448-1.632-4.105-1.632-3.314 0-6 2.738-6 6.117 0 3.378 2.686 6.116 6 6.116 3.313 0 5.665-1.953 5.66-6.116.006-.258 0-.508-.017-.752h2.07v.085c.78 5.83-3.115 9.187-7.783 9.144-4.593-.006-8.315-3.795-8.315-8.477s3.722-8.478 8.314-8.478c2.4 0 4.419.855 5.798 2.34Z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 29,
    height: 33,
    x: 13,
    y: 8,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.21 22.884c1.734 1.009 1.733 2.644 0 3.653L16.139 40.542C14.405 41.551 13 40.745 13 38.74V10.683c0-2.005 1.405-2.812 3.139-1.803L40.21 22.884Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M40.21 22.884c1.733 1.01 1.733 2.645 0 3.653L16.137 40.542c-1.734 1.009-3.139.203-3.139-1.803V10.683c0-2.004 1.406-2.812 3.139-1.803l24.071 14.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M12.977 8.442 28.72 24.45 12.774 41.09l.203-32.648Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "m9.74 5.146 18.98 19.308 5.643-5.507L9.74 5.146Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "m28.724 24.45 8.638 8.909-25.807 8.907 17.169-17.815Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 41.509,
    x2: 30.415,
    y1: 24.711,
    y2: 24.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 12.774,
    x2: 24.473,
    y1: 27.533,
    y2: 25.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 14.734,
    x2: 26.649,
    y1: 9.027,
    y2: 24.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.779,
    x2: 20.544,
    y1: 27.556,
    y2: 44.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayButton);
export default __webpack_public_path__ + "static/media/GooglePlayButton.23bb43997622a3a69de1e59de0974cd0.svg";
export { ForwardRef as ReactComponent };